import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';

export const EventDetailGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getSelectedEventLoaded)
    .pipe(
      tap(loaded => {
        const id = +route.params['eventId'] || +route.data['eventId'];
        const eventDate = route.params['eventDate'];
        if (!loaded) {
          store.dispatch(fromStore.LoadEventById({ id, eventDate }));
        }
        if (id) {
          store.dispatch(fromStore.LoadRelatedEvents({ eventId: id }));
        }
      }),
      filter(loaded => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};

export const EventDetailNoDateGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getSelectedEventLoaded)
    .pipe(
      tap(loaded => {
        const id = +route.params['eventId'] || +route.data['eventId'];
        if (!loaded) {
          store.dispatch(fromStore.LoadEventById({ id, eventDate: undefined }));
        }
      }),
      filter(loaded => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
